import { z } from 'zod';
export const publicBusinessLinkKindSchema = z.enum([
    'website',
    'x',
    'instagram',
    'facebook',
    'tiktok',
    'whatsapp',
    'telegram',
    'youtube',
    'linkedin',
    'snapchat',
    'directions',
    'document',
    'other',
]);
export const publicBusinessLinkSchema = z.object({
    label: z.string().trim().min(1).max(80),
    url: z.string().max(2048),
    kind: publicBusinessLinkKindSchema,
    description: z.string().trim().max(140).optional(),
    fileId: z.uuid().optional(),
}).superRefine((link, context) => {
    if (link.fileId) {
        if (link.kind !== 'document' || link.url !== `/api/public/link-documents/${link.fileId}`) {
            context.addIssue({ code: 'custom', path: ['url'], message: 'Use the uploaded document URL.' });
        }
        return;
    }
    try {
        const url = new URL(link.url);
        if (url.protocol !== 'https:' || url.username || url.password)
            throw new Error('Unsafe URL');
    }
    catch {
        context.addIssue({ code: 'custom', path: ['url'], message: 'Public links must use HTTPS without credentials.' });
    }
});
export const maximumPublicLinks = 30;
export const maximumLinkDocumentBytes = 10 * 1024 * 1024;
//# sourceMappingURL=public-links.js.map